import React, { useEffect, useContext, useState, useRef } from 'react';
import ApplicationContext from './ApplicationContext';
import "../assets/css/petro.css";
import { getDataWithFetch, getLocalStorage } from './Utils';
import CreditCardForm from './CreditCardForm';

const Petro = () => {
    const data = useContext(ApplicationContext);
    const [enableStripe, setEnableStripe] = useState();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handlePaymentClick = () => {
        setIsDialogOpen(true);
    };
  
    const closeDialog = () => {
        // console.log("calling closeDialog now");
        setIsDialogOpen(false);
    };

	useEffect(() => {
		setEnableStripe(data.enableStripe);
	}, [data.enableStripe]);

    const loaded = useRef(false);
    const [authToken, setAuthToken] = useState(getLocalStorage('token'));
    // console.log('DEBUG', `Petro - token = ${authToken}`)
    const [bpdData, setBPDData] = useState();
    useEffect(() => {
        ((async() => {
            // TODO add authToken back in, in the final release once montization is figured out.  Shafagh is being a retard.
            // if (loaded.current === false && data.BASE_URL) {
            if (loaded.current === false && data.BASE_URL && authToken) {
                loaded.current = true;
                const get_petro_reports_url = data.BASE_URL + "index.php/misc/get_petro_reports";
                // console.log("DEBUG:  ", get_petro_reports_url);
                const res = await getDataWithFetch(get_petro_reports_url, authToken);
                // console.log("DEBUG", res?.data);
                if (res?.data) {
                    setBPDData(res?.data);
                }
            }
        })());
    }, [authToken, data.BASE_URL]);

    // useEffect(() => {
    //     console.log("DEBUG:  bpdData = ", bpdData);
    //     if (bpdData) {
    //         const bpdDataFormatted = formatBDPData(bpdData);
    //         console.log("DEBUG:  bpdDataFormatted = \n", bpdDataFormatted);
    //     }
    // }, [bpdData]);

    const displayBpEntry = (entry, index, arr) => {
        let res = (<></>);

        // Skip the last one we cannot diff it to anything
        if (index !== arr?.length-1) {
            let keys = Object.keys(entry);
            if (keys?.length === 1) {
                const unformattedCurrentEntry = entry[keys[0]];
                const currentEntry = entry[keys[0]].replace(",","");
                const nextKeys = Object.keys(arr[index+1]);
                let diff = 0;
                if (nextKeys.length === 1) {
                    const nextEntry = arr[index+1][nextKeys[0]].replace(",","");
                    diff = parseInt(currentEntry) - parseInt(nextEntry)
                }

                // console.log("DEBUG:  index = ", (index+1).toString())
                res = (
                    <div key={index+1} className='petro-item-container'>
                        <div className='petro-quote-item'>
                            <div className="petro-name-value-label-container">
                                <div className="petro-name-value-label">
                                    <div>{keys[0].replaceAll("-", "/")}</div>
                                </div>
                            </div>
                            <div className="petro-name-value-label-container">
                                {/* style={{fontWeight: 'bold'}} */}
                                <div className="petro-name-value-label">
                                    <div>{unformattedCurrentEntry}</div>
                                </div>
                            </div>
                            <div className="petro-name-value-label-container">
                                <div className={"petro-name-value-label " + (diff < 0 ? "negative-growth" : "positive-growth")}>
                                    <div>{diff}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
            // Shouldn't ever be called but putting this code if the data is 
            // fucked up or some other unforseen error condition.
            else {
                res = (
                    <div key={index+1} className='petro-item-container'>
                    </div>
                )
            }
        }
        // Fixing by adding a key attribute for an empty div so the map is 
        // complete.  This div is hidden anyway, I just want to clean up the 
        // output on Chrome and Safari.
        else {
            res = (
                <div key={index+1} className='petro-item-container'>
                </div>
            )
        }

        return res;
    }

    useEffect(() => {
        // console.log('DEBUG:  Petro - data.authToken = ', data.authToken)
        setAuthToken(data.authToken);
    }, [data, data.authToken]);

	return (
		<>
			<h3>US Oil Production (x1000 barrels per day) updated weekly</h3>
			<div>
                <div className="petro-quote-container">
                    {!authToken && 
                        <>
                            {/* This section is undergoing maintenance and monetization review */}
                            {/* This section for subscribers for $14 per month. */}
                            <p onClick={handlePaymentClick} className="petro-quote-container-dimm">
                                This section for subscribers for $14 per month.
                            </p>
                            {/* "petro-quote-container-dimm" */}
                            {/* <div onClick={handlePaymentClick} className="payment-container">
                                <p className="all-links link-title">
                                    This section for subscribers for $14 per month. What you get:
                                </p>
                                <ul className="all-links link-title">
                                    <li>US Crude and Petroleum Bi-Weekly Output Reporting.</li>
                                    <li>US Energy Sector Insights.</li>
                                    <li>Add-ons in the US Energy Sector Reporting if any and / or Applicable.</li>
                                </ul>
                            </div> */}
                            {/* This section iw 5o enable the credit card form for monetization.  We don't quite have this working as of yet so just comment out so we can get a build out. */}
                            {enableStripe && <CreditCardForm isOpen={isDialogOpen} onClose={(e) => {
                                // console.log("onClose CreditCardForm");
                                closeDialog();
                            }} />}
                        </>
                    }
                    {authToken && bpdData && bpdData?.map((entry, index, arr) => {
                        return displayBpEntry(entry, index, arr);
                    })}

                    {/* 
                        TODO remove this, I just want to make bpData always available without 
                        authentication in this build.  We are in the process of getting monetization 
                        figured out but Shafagh is being a guber and super annoying.
                    */}
                    {/* {bpdData && bpdData?.map((entry, index, arr) => {
                        return displayBpEntry(entry, index, arr);
                    })} */}

                </div>
			</div>
		</>
	);
}

export default Petro;
